import { addDays } from 'date-fns';
import { useToggle } from 'hooks';
import { CartItem } from 'models/CartItem';
import { EndCalendar } from './endCalendar';
import { StartCalendar } from './startCalendar';
import styles from './rentalPeriod.scss';

export interface Props {
  setPickupDate: (date: Date) => void;
  setReturnDate: (date: Date | undefined) => void;
  dispatchRentalPeriod: () => void;
  selectedPickupDate: Date | undefined;
  selectedReturnDate: Date | undefined;
  shouldBeDisabled: boolean;
  item: CartItem;
}

export const getDefaultDays = (days: number): Date => {
  return new Date(addDays(new Date(), days).toDateString());
};

const DEFAULT_DAYS = 3;
export const RentalPeriod = ({
  item,
  selectedPickupDate,
  selectedReturnDate,
  setPickupDate,
  setReturnDate,
  shouldBeDisabled,
  dispatchRentalPeriod
}: Props) => {
  const defaultReturnStartDate = getDefaultDays(DEFAULT_DAYS);

  const [showPickupDateSelector, toggleShowPickupDateSelector] = useToggle(false);
  const [showReturnDateSelector, toggleShowReturnDateSelector] = useToggle(false);

  return (
    <div className={styles.rentalContainer}>
      <StartCalendar
        setPickupDate={setPickupDate}
        item={item}
        defaultReturnStartDate={defaultReturnStartDate}
        dispatchRentalPeriod={dispatchRentalPeriod}
        selectedPickupDate={selectedPickupDate}
        selectedReturnDate={selectedReturnDate}
        setReturnDate={setReturnDate}
        shouldBeDisabled={shouldBeDisabled}
        showPickupDateSelector={showPickupDateSelector}
        toggleShowPickupDateSelector={toggleShowPickupDateSelector}
        toggleShowReturnDateSelector={toggleShowReturnDateSelector}
      />
      <EndCalendar
        defaultReturnStartDate={defaultReturnStartDate}
        dispatchRentalPeriod={dispatchRentalPeriod}
        selectedPickupDate={selectedPickupDate}
        selectedReturnDate={selectedReturnDate}
        setReturnDate={setReturnDate}
        shouldBeDisabled={shouldBeDisabled}
        toggleShowPickupDateSelector={toggleShowPickupDateSelector}
        toggleShowReturnDateSelector={toggleShowReturnDateSelector}
        showReturnDateSelector={showReturnDateSelector}
      />
    </div>
  );
};
